// extracted by mini-css-extract-plugin
export default {"empty-list-icon":"EmptyListIcon_empty-list-icon__Si-3f","empty-list-icon__text":"EmptyListIcon_empty-list-icon__text__+WlBw"};